<template>
    <datepicker id="datepicker" class="js-datepicker" :locale="locale" v-model="currentDate" :lowerLimit="new Date()" ref="datePicker" v-show="displayDatePickerFlg" @update:modelValue="handleDate"/>
    <input id="datepicker" type="text" v-model="currentDateDisplay" v-on:click="displayDatepicker" v-show="displayDatePickerLabelFlg"/>
</template>

<script>
    import Datepicker from 'vue3-datepicker'
    import { ja } from 'date-fns/locale'
    import { ref, watchEffect } from 'vue'
    export default ({
        components: {
            Datepicker
        },
        props: {
            // 引数の受け問
            condition : {type: Object, require: true},
        },
        setup (props, context) {
            const currentDate = ref(new Date(props.condition.selectedDate.value))
            const currentDateDisplay = ref(new Date(props.condition.selectedDate.value))
            const displayDatePickerFlg = ref(false)
            const displayDatePickerLabelFlg = ref(true)

            // isMonthがtrueだったら、表示を変更する。
            if (props.condition.selectedDate.isMonth == true) {
                let targetMoment = dayjs(currentDateDisplay.value)
                currentDateDisplay.value = targetMoment.format("YYYY年M月未定")
            } else {
                displayDatePickerFlg.value = true
                displayDatePickerLabelFlg.value = false
            }

            const handleDate = (modelData) => {
                props.condition.selectedDate.isMonth = false
            }

            watchEffect(() => {
                context.emit("targetDate", currentDate.value)
            })

            let locale = ja

            return {
                currentDate,
                currentDateDisplay,
                displayDatePickerFlg,
                displayDatePickerLabelFlg,
                locale,
                handleDate,
            }
        },
        methods: {
            displayDatepicker: function() {
                this.displayDatePickerFlg = true
                this.displayDatePickerLabelFlg = false
                let datePicker = this.$refs.datePicker
                datePicker.renderView(datePicker.initialView);
            },
        },
        emits: ['targetDate']
    })
</script>